import { message } from "antd";
import { useState } from "react";

import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { showErrorToast } from "V2.0/utils";

export default BulkCampaignResume;

interface BulkCampaignResumeProps {
  onClose: () => void;
  bulkCampaign: any;
  onBulkCampaignResume: (
    bulkCampaignId: string,
    lifecycleCbs: {
      init: () => void;
      success: () => void;
      error: (e: any) => void;
    },
  ) => void;
}

function BulkCampaignResume(props: BulkCampaignResumeProps) {
  const { onClose, bulkCampaign, onBulkCampaignResume } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const handleResume = () => {
    const init = () => {
      setLoading(true);
      message.loading(`Resume ${bulkCampaign.name}`);
    };

    const success = () => {
      setLoading(false);
      message.destroy();
      onClose();
      message.success(`${bulkCampaign.name} Resumed`);
    };

    const error = (e: any) => {
      setLoading(false);
      message.destroy();
      showErrorToast(e, `Failed to resume ${bulkCampaign.name}`);
    };

    onBulkCampaignResume(bulkCampaign._id, { init, success, error });
  };

  const title = `Resume ${bulkCampaign.name}?`;

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleResume}
          disabled={loading}
        >
          Resume
        </Button>
      </DialogActions>
    </Dialog>
  );
}
